import { render, staticRenderFns } from "./HomeVideoItem.vue?vue&type=template&id=4e01a816&scoped=true"
import script from "./HomeVideoItem.vue?vue&type=script&lang=js"
export * from "./HomeVideoItem.vue?vue&type=script&lang=js"
import style0 from "./HomeVideoItem.vue?vue&type=style&index=0&id=4e01a816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e01a816",
  null
  
)

export default component.exports